import {
  FormControl,
  Grid,
  Select as MuiSelect,
  InputLabel,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useRef, useState } from "react";
import Staff from "../../actions/staff";
import Roles from "../../actions/role";

import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";

const initialFValues = {
  fullName: "",
  phoneNo: "",
  roles: [],
  email: "",
  editing: false,
};

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));

const AddStff = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setStaffs,
  getAllStaffs,
  edite,
}) => {
  const classes = useStyles();
  const { addStaff, updateStaff } = Staff();
  const [roles, setRoles] = useState([]);
  const { viewAllRoles } = Roles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [roleError, setRoleError] = useState(false);
  const firstFieldRef = useRef(null);

  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("fullName" in fieldValues)
      temp.fullName =
        fieldValues.fullName.length != 0 ? "" : "This field is required.";
    if ("phoneNo" in fieldValues)
      temp.phoneNo =
        fieldValues.phoneNo.length != 0 ? "" : "This field is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(fieldValues.email.toString().toLowerCase())
          ? ""
          : "Email is not valid.";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  useEffect(() => {
    getAllRoles();
  }, []);

  useEffect(() => {
    if (recordForEdit !== null) {
      const initialSelectedOptions = recordForEdit.staffRoles
        .map((staffRole) => roles.find((role) => role.id === staffRole.role.id))
        .filter((role) => role); // Filter out any undefined results

      setSelectedOptions(initialSelectedOptions);
      setValues({
        ...recordForEdit,
        roles: initialSelectedOptions.map((role) => role.id), // Store IDs only in values
      });
    }
  }, [recordForEdit, roles]);

  const getAllRoles = () => {
    viewAllRoles().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.roles) {
        setRoles(data.roles);
      }
    });
  };

  const handleChange = (event) => {
    const selectedIds = event.target.value;
    const selectedRoles = roles.filter((role) => selectedIds.includes(role.id));
    setSelectedOptions(selectedRoles);
    setValues({
      ...values,
      roles: selectedIds,
    });
  };

  const handleSubmit = () => {
    if (validate()) {
      if (values.roles.length === 0) {
        setRoleError(true);
        return;
      }
      setRoleError(false);
      setValues({ ...values, submitting: true });
      if (edite === false) {
        delete values.logginError;
        delete values.editing;
        addStaff(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if (data.staff) {
            NotifyMessage({
              message: data.staff.password,
              type: "success",
            });
            setOpenPopup(false);
            getAllStaffs();
            resetForm();
          }
        });
      } else {
        delete values.logginError;
        delete values.editing;
        updateStaff(values, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Staff successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            getAllStaffs();
          }
        });
      }
    }
  };

  const handleAddClick = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="fullName"
            label="Full Name"
            value={values.fullName}
            onChange={handleInputChange}
            error={errors.fullName}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl variant="outlined" {...(roleError && { error: true })}>
            <InputLabel>Select Roles</InputLabel>
            <MuiSelect
              label="Select Roles"
              name="roles"
              multiple
              value={values.roles}
              onChange={handleChange}
            >
              {roles.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
              ))}
            </MuiSelect>
            {roleError && (
              <FormHelperText error>
                Please select at least one role
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite === true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              type="submit"
            />
            <Controls.Button
              text="Cancel"
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddStff;
